var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"sw-Loading"},[_c('img',{staticClass:"sw-Loading_Img",attrs:{"src":require("common/loading.gif"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }